import parserUtils from './utils'
import { toNumber, get, toLower, cloneDeep } from 'lodash'
import { formatDate } from '@/utils/helpers'
import { Audience } from '@node/wam-audience-builder'

const helpers = {
    apiToStore: val => {
        const has_1st_party = parserUtils.hasFirstParty(val.generic_formula)
        const has_3rd_party = parserUtils.hasThirdParty(val.generic_formula)
        const isThirdParty = !has_1st_party && has_3rd_party

        return {
            id: toNumber(val.id),
            label: val.label,
            isSelectable: true,
            hasChild: false, //tree prop
            parentJsonKeyName: null,
            status: val.status,
            bootstrap: val.bootstrap,
            bootstrapPeriod: toNumber(val.bootstrap_period),
            createdAt: formatDate(val.created_at, true, true),
            endDate: formatDate(val.end_date),
            type: toLower(val.audience_type),
            sharedAudience: val.sharing_parent_id,
            isShared: val.sharing_parent_id !== null,
            waxAudiences: null, //in audience table, check sharing_parent_id === val.id ==> later : null || [ids || {}]
            email: val.email,
            cc: val.email_cc,
            maxRecency: val.audience_type === 'Cclones' ? 30 : parserUtils.getMaxRecency(val.generic_formula),
            hasGeodemo: val.has_geodemo,
            has_1st_party,
            has_3rd_party,
            isThirdParty,
            jsonKey: {
                ids: [toNumber(val.id)],
                name: 'audience_' + val.id,
                type: 'Audience',
                subType: val.audience_type
            },
            tags: get(val, 'tags', null),
            formula: val.generic_formula,
            volume: 'n/a',
            volumes: null,
            volumeAlert: {
                isLoading: false,
                details: {},
                isVisibleInMonitoringPanel: false
            },
            summary: {},
            strong_classifiers_family_id: val.strong_classifiers_family_id,
            breakdown: null,
            shouldShowBootstrap({ bootstrapPush, managerAccess, userRole }) {
                if (toLower(val.audience_type) === 'cclones') return true
                if (userRole === 'webo_admin') return true
                if (bootstrapPush) {
                    if (isThirdParty) return true
                    if (userRole === 'webo_employee' || (userRole === 'webo_user' && managerAccess === 'write')) {
                        return has_1st_party
                    }
                }
                return false
            },
            isThirdPartyBootstrap({ bootstrapPush, managerAccess, userRole }) {
                return (
                    bootstrapPush &&
                    isThirdParty &&
                    toLower(val.audience_type) !== 'cclones' &&
                    (userRole === 'webo_user' && managerAccess === 'write')
                )
            },
            isBootstrapAllowed({ userRole, getThirdPartyOnlyInAudienceFormula }) {
                return (
                    ['webo_admin', 'webo_employee'].includes(userRole) ||
                    toLower(val.audience_type) === 'cclones' ||
                    (userRole !== 'webo_admin' && !getThirdPartyOnlyInAudienceFormula({ formula: val.generic_formula }))
                )
            }
        }
    },

    parseData: data => {
        const _data = []
        for (const val of data) {
            _data.push(helpers.apiToStore(val))
        }
        return _data
    },

    instanciateAll: audiences => {
        return audiences.filter(audience => audience.status == 'active').map(helpers.instanciate)
    },

    instanciate: audience =>
        new Audience({
            id: audience.id,
            label: audience.label,
            tags: audience.tags || [],
            genericFormula: formatGenericFormulas(audience?.generic_formula),
            subCategory: audience.audience_type,
            path: audience.sharing_parent_id ? ['Sharing', 'Audiences'] : ['Audiences', 'Audience'],
            displayId: true,
            isShared: audience.sharing_parent_id ? true : false,
            sharingParentId: audience.sharing_parent_id || false,
            recency: parserUtils.getMaxRecency(audience.generic_formula) === 395 ? 395 : 30
        })
}

const formatGenericFormulas = genericFormula => {
    if (!genericFormula) return null
    const clone = cloneDeep(genericFormula)
    let formula = []

    function unifyIds(id) {
        return !isNaN(id) ? parseFloat(id) : id
    }

    if (Array.isArray(clone)) {
        clone.forEach(criterion => {
            const ids = []
            if (typeof criterion === 'object' && criterion.hasOwnProperty('ids')) {
                criterion?.ids.forEach(id => {
                    ids.push(unifyIds(id))
                    criterion.ids = ids
                })
            }
            formula.push(criterion)
        })
    } else {
        const ids = []
        clone?.ids.forEach(id => {
            ids.push(unifyIds(id))
        })
        formula = clone
        formula.ids = ids
    }

    return formula
}

export default helpers
